<template>
    <div>
        <!-- {{ positionAvailabe }} -->

        <!-- loading: {{ loading }} -->

        <div class="map-disclaimer">
            Es werden nur Ideen mit Adressen angezeigt. Für alle Ideen zur
            <span @click="$emit('toggle', true)">Listenansicht wechseln</span>.
        </div>

        <div class="">
            <GmapMap
                :center="{ lat: latNow, lng: lngNow }"
                :zoom="zoom"
                :options="{
          styles: myStyle,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: false,
        }"
                style="width: 100%; height: 500px; border-radius: 6px"
            >
                <!-- <gmap-info-window
                  :position="{lat: 47.3766, lng: 8.5418401}"
                  :opened="true"
                  @closeclick="infoWinOpen = false"
                >
                </gmap-info-window> -->
                <div class="map-need-overlay">
                    <div class="close">
                        <img
                            alt="Schließen"
                            @click.prevent="hideOverlay()"
                            class="close-x"
                            src="/img/icons/close-dark.svg"
                        />
                    </div>
                    <div id="map-category">
                        {{ selected ? category_name : "" }}
                    </div>
                    <div class="map-info-links">
                        <a id="map-title" class="toIdea" href="">
                            {{ selected ? selected.title : "" }}
                        </a>

                        <a id="map-route" target="_blank" :href="route_link">Route</a>
                    </div>
                    <div class="info-wrapper">
                        <div id="map-rating">
                            {{
                                selected
                                    ? selected.average_rating == null
                                        ? "0.0"
                                        : parseFloat(selected.average_rating).toFixed(1)
                                    : ""
                            }}
                            <img alt="Bewertung" src="/img/icons/star.svg"/>
                        </div>
                        <!-- <a href="" class="toIdea">Zur Idee</a> -->
                        <!-- <div @click.prevent="toIdea(idea.id)" class="toIdea">Zur Idee</div> -->

                        <div id="map-age">
                            <img alt="Alter" src="/img/icons/people.svg"/>{{
                                selected ? age_output : ""
                            }}
                        </div>
                        <div id="map-cost">
                            <img alt="Kosten" src="/img/icons/cash.svg"/>{{ selected ? cost_output : "" }}
                        </div>
                        <!--
                        <div id="map-indoor">
                          <img src="/img/icons/house.svg" />{{
                            selected ? location_output : ""
                          }}
                        </div> -->
                    </div>
                </div>
                <div
                    v-for="idea in ideas"
                    :key="
            'marker_m' +
            idea.category_id +
            '_' +
            filters.category.sub +
            '_' +
            idea.id
          "
                >
                    <gmap-custom-marker
                        @click.native="openIdea(idea)"
                        :marker="{
              lat: parseFloat(idea.latitude),
              lng: parseFloat(idea.longitude),
            }"
                    >
                        <img alt="Marker" src="/map-marker.svg"/>
                    </gmap-custom-marker>
                </div>
            </GmapMap>
        </div>
    </div>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";

export default {
    components: {
        "gmap-custom-marker": GmapCustomMarker,
    },
    props: ["mapPosition", "filters"],
    data() {
        return {
            // ideas: [],
            positionAvailabe: false,
            loading: true,
            lat: 47.3766,
            lng: 8.5418401,
            zoom: 14,
            selected: null,
            ideas: [],
            myStyle: [
                {
                    featureType: "administrative",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#0e5c84",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#fbc1ac",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                        {
                            saturation: "0",
                        },
                        {
                            lightness: "0",
                        },
                        {
                            weight: "1",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#fff1eb",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "all",
                    stylers: [
                        {
                            color: "#94dafd",
                        },
                        {
                            visibility: "on",
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        hideOverlay() {
            document.querySelector(".vue-map-hidden").style.display = "none";
        },
        toIdea(id) {
            window.open("https://ave-family.com/idee/" + id);
        },
        openIdea(idea) {
            this.selected = idea;
            document
                .querySelector(".toIdea")
                .setAttribute("href", "https://ave-family.com/idee/" + idea.id);
            document.querySelector(".vue-map-hidden").style.display = "block";
        },

        async getIdeas() {
            console.log("this.filters", this.filters, this.lat, this.lng);
            const {data} = await axios.get("/api/ideas", {
                params: {
                    filters: this.myFilters,
                    page: this.page,
                    geolocation: {lat: this.lat, lng: this.lng},
                },
            });
            console.log("incoming", data.ideas);
            console.log("filters", this.filters);
            this.ideas = data.ideas;
        },
    },
    mounted() {
        this.getIdeas();
    },
    created() {
    },
    beforeCreate() {
    },
    computed: {
        route_link: function () {
            if (this.selected !== null) {
                return (
                    "https://www.google.com/maps/dir/?api=1&destination=" +
                    this.selected.latitude +
                    "," +
                    this.selected.longitude
                );
            } else {
                return "#";
            }
        },
        category_name: function () {
            if (this.selected.subsubcategory !== null) {
                return this.selected.subsubcategory.title;
            } else if (this.selected.subcategory !== null) {
                return this.selected.subcategory.title;
            } else {
                return this.selected.category.title;
            }
        },
        cost_output: function () {
            let output = "";
            if (this.selected.price_from == null && this.selected.price_to == null) {
                output = "Keine Angabe";
            } else if (
                (this.selected.price_from == 0 && this.selected.price_to == null) ||
                (this.selected.price_from == 0 && this.selected.price_to == 0)
            ) {
                output = "Gratis";
            } else if (
                this.selected.price_from !== null &&
                this.selected.price_to == null
            ) {
                output = this.selected.price_from + " CHF";
            } else {
                output =
                    this.selected.price_from + " - " + this.selected.price_to + " CHF";
            }

            return output;
        },
        age_output: function () {
            let output = "";
            if (this.selected.age_from == null && this.selected.age_to == null) {
                output = "Keine Angabe";
            } else if (
                this.selected.age_from !== null &&
                this.selected.age_to == null
            ) {
                output = "Ab " + this.selected.age_from + " Jahren";
            } else if (
                this.selected.age_from !== null &&
                this.selected.age_to !== null
            ) {
                output =
                    this.selected.age_from + " - " + this.selected.age_to + " Jahren";
            }
            return output;
        },
        location_output: function () {
            let output = "";
            if (this.selected.indoor == true && this.selected.outdoor == true) {
                return "Drinnen/Draussen";
            } else if (
                this.selected.indoor == false &&
                this.selected.outdoor == false
            ) {
                return "Keine Angabe";
            } else if (
                this.selected.indoor == true &&
                this.selected.outdoor == false
            ) {
                return "Drinnen";
            } else if (
                this.selected.indoor == false &&
                this.selected.outdoor == true
            ) {
                return "Draussen";
            }
        },
        latNow: function () {
            return this.mapPosition ? this.mapPosition.latitude : this.lat;
        },
        lngNow: function () {
            return this.mapPosition ? this.mapPosition.longitude : this.lng;
        },
        myFilters: function () {
            // let filters = this.filters;
            let filters = _.cloneDeep(this.filters);

            filters.map = true;
            filters.geolocation = {
                latitude: this.mapPosition ? this.mapPosition.latitude : this.lat,
                longitude: this.mapPosition ? this.mapPosition.longitude : this.lng,
            };
            return filters;
        },
    },
    watch: {
        filters: function (newData, oldData) {
            console.log("filters has change", newData, oldData);
        },
        "filters.geolocation.latitude": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.category.main": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.category.sub": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.category.subsub": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.age": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.cost": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.duration": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.amount": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.preperation": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.infra": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.objectives": function (newData, oldData) {
            this.getIdeas();
        },
        "filters.local": function (newData, oldData) {
            this.getIdeas();
        },
    },
};
</script>

<style>
</style>
